import {useRef, useState} from 'react';

import BusinessWalletBalance from './BusinessWalletBalance';
import FundBusinessWallet from './FundBusinessWallet';
import type {BusinessTransactionsViewProps, WalletFundRequest} from './types';

const BusinessTransactionsView = ({
  walletBalances,
  isLoadingWalletBalances,
  business,
}: BusinessTransactionsViewProps) => {
  // Captured once, at the moment a wallet card's Credit/Debit button is
  // clicked — the modal it opens always knows exactly which wallet it's
  // acting on, with nothing "currently selected" to drift out of sync.
  const [fundingRequest, setFundingRequest] =
    useState<WalletFundRequest | null>(null);
  // Unique per request (not per wallet/action) so reopening the same
  // wallet+action after a cancelled attempt still remounts with a clean
  // form instead of carrying over a stale amount/reason.
  const nextRequestId = useRef(0);

  return (
    <>
      <BusinessWalletBalance
        businessId={business?.id ?? ''}
        businessName={business?.name}
        isLoadingWalletBalances={isLoadingWalletBalances}
        walletBalances={walletBalances}
        onRequestFund={(walletType, action) => {
          nextRequestId.current += 1;
          setFundingRequest({id: nextRequestId.current, walletType, action});
        }}
      />

      {fundingRequest && (
        <FundBusinessWallet
          key={fundingRequest.id}
          business={business}
          walletType={fundingRequest.walletType}
          initialAction={fundingRequest.action}
          isOpen
          onClose={() => setFundingRequest(null)}
        />
      )}
    </>
  );
};

export default BusinessTransactionsView;
